export const video_kv_sources: any = {
    // us: 'https://www.youtube.com/embed/lpIFKQ5HlH8',
    us: 'https://www.youtube.com/embed/zsonj2HPQdM?si=RQjWvnLhQId7waFm',
    sa: 'https://www.youtube.com/embed/cHSA9zIk0cU',
    za: 'https://www.youtube.com/embed/R3cUJ1g-QTI?si=ZRva0v7YIq2vxNjr',
};

export const videoLists: any[] = [
    {
        source: 'https://www.youtube.com/embed/JcKq6neGxXk?si=leKqBnkHVezJuNA-',
        desc: 'secL_card5',
        poster: ['/img/landingPage/poster5.jpg', '/img/landingPage/poster5.jpg'],
    },
    {
        source: 'https://www.youtube.com/embed/_zYHtNnuO-A?si=nRQPeg0JqmOFgqKL',
        desc: 'secL_card6',
        poster: ['/img/landingPage/poster6.jpg', '/img/landingPage/poster6.jpg'],
    },
    {
        source: 'https://www.youtube.com/embed/Uat1fPVoR4w',
        desc: 'secL_card1',
        poster: ['/img/landingPage/poster1.jpg', '/img/landingPage/poster1.jpg'],
    },
    {
        source: 'https://www.youtube.com/embed/bXd-aP06lug',
        desc: 'secL_card2',
        poster: ['/img/landingPage/poster2.jpg', '/img/landingPage/poster2.jpg'],
    },
    {
        source: 'https://www.youtube.com/embed/ddI0e46Dbb0',
        desc: 'secL_card3',
        poster: ['/img/landingPage/poster3.jpg', '/img/landingPage/poster3.jpg'],
    },
    {
        source: 'https://www.youtube.com/embed/yNBXE3BszEM',
        desc: 'secL_card4',
        poster: ['/img/landingPage/poster4.jpg', '/img/landingPage/poster4.jpg'],
    },
];
